<div [ngSwitch]="view" class="max-h-[65vh] overflow-auto pr-1">
  <section class="pb-4 flex gap-4 justify-between sticky top-0 bg-white z-10">
    <div class="flex gap-2">
      <div>
        <button
          ndt-icon-button
          mwlCalendarPreviousView
          type="button"
          class="ml-auto lg:ml-0"
          [view]="view"
          [(viewDate)]="viewDate"
          (viewDateChange)="onDateChange(); closeActiveDayView()"
          aria-label="Poprzedni"
          i18n-aria-label
          ><app-icon name="chevron-left"></app-icon
        ></button>
        <button
          type="button"
          ndt-icon-button
          mwlCalendarNextView
          [view]="view"
          [(viewDate)]="viewDate"
          (viewDateChange)="onDateChange(); closeActiveDayView()"
          aria-label="Następny"
          i18n-aria-label
          ><app-icon name="chevron-right"></app-icon
        ></button>
        <button mwlCalendarToday [(viewDate)]="viewDate" ndt-tertiary-button type="button"
          ><app-icon name="calendar"></app-icon>
          <ng-container i18n>Dzisiaj</ng-container>
        </button>
      </div>

      <div class="inline-flex gap-4 w-full lg:w-auto">
        <span class="text-lg font-semibold order-first lg:order-none">
          {{ viewDate | calendarDate: view + 'ViewTitle' : locale : weekStartsOn }}
        </span>
      </div>
    </div>

    <div class="ml-auto lg:ml-0 inline-flex gap-4 lg:right-0">
      <button
        *ngFor="let mode of calendarViewOptions"
        ndt-tertiary-button
        type="button"
        (click)="view = mode.value; onDateChange()"
        ><app-icon [name]="mode.icon"></app-icon>
        <span class="hidden sm:inline lg:hidden xl:inline">{{ mode.label }}</span>
      </button>
    </div>
  </section>

  <mwl-calendar-month-view
    *ngSwitchCase="calendarView.Month"
    [activeDayIsOpen]="activeDayIsOpen"
    [events]="data"
    [locale]="locale"
    [tooltipAppendToBody]="false"
    [viewDate]="viewDate"
    [weekStartsOn]="weekStartsOn"
    (dayClicked)="dayClicked($event.day)"
    (eventClicked)="eventClick.emit($event.event)"
  >
  </mwl-calendar-month-view>
  <mwl-calendar-week-view
    *ngSwitchCase="calendarView.Week"
    [events]="data"
    [locale]="locale"
    [tooltipAppendToBody]="false"
    [viewDate]="viewDate"
    [weekStartsOn]="weekStartsOn"
    (eventClicked)="eventClick.emit($event.event)"
  ></mwl-calendar-week-view>
  <mwl-calendar-day-view
    *ngSwitchCase="calendarView.Day"
    [events]="data"
    [locale]="locale"
    [tooltipAppendToBody]="false"
    [viewDate]="viewDate"
    (eventClicked)="eventClick.emit($event.event)"
  ></mwl-calendar-day-view>
</div>
